import { CSSProperties } from 'react';
import { ProfileResponse } from 'api';

export type PurchaseProfilesLocationState = {
  evaluationId?: string;
};

const hasEvaluationId = (
  state: unknown,
): state is Required<PurchaseProfilesLocationState> =>
  typeof state === 'object' &&
  state !== null &&
  'evaluationId' in state &&
  typeof state.evaluationId === 'string';

export const getPurchaseEvaluationId = (
  locationState: unknown,
  profiles: ProfileResponse[],
  latestEvaluationId?: string,
) => {
  if (!hasEvaluationId(locationState)) {
    return latestEvaluationId;
  }

  const { evaluationId } = locationState;
  const learnerHasEvaluation = profiles.some(
    ({ evaluation }) => evaluation.id === evaluationId,
  );
  return learnerHasEvaluation ? evaluationId : undefined;
};

export const truncatedTextStyles: CSSProperties = {
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
  paddingLeft: '2px',
};
